import { Search } from "vant";

const getters = {
    userInfo: (state) => state.userInfo, 
    screenWidthType: (state) => state.screenWidthType,
    screen: (state) => state.screen,
    dictionary: (state) => {a:1},
    videoToText:(state) => state.videoToText
  };
  
  export default getters;

  


// WEBPACK FOOTER //
// ./src/store/getter.js